import ReactModal from 'react-modal'

if (typeof document !== 'undefined') {
  let modalRoot = document.getElementById('root')
  if (!modalRoot) {
    modalRoot = document.createElement('div')
    modalRoot.setAttribute('id', 'root')
    document.body.appendChild(modalRoot)
  }
  ReactModal.setAppElement(modalRoot)
}

export default ReactModal
